// This is copied directly from the AGORA package

export enum AudioProfile {
  /**
   * 0: Default audio profile.
   * - In the `Communication` profile: A sample rate of 32 KHz, audio encoding, mono, and a bitrate of up to 18 Kbps.
   * - In the `LiveBroadcasting` profile: A sample rate of 48 KHz, music encoding, mono, and a bitrate of up to 64 Kbps.
   */
  Default = 0,
  /**
   * 1: A sample rate of 32 KHz, audio encoding, mono, and a bitrate of up to 18 Kbps.
   */
  SpeechStandard = 1,
  /**
   * 2: A sample rate of 48 KHz, music encoding, mono, and a bitrate of up to 64 Kbps.
   */
  MusicStandard = 2,
  /**
   * 3: A sample rate of 48 KHz, music encoding, stereo, and a bitrate of up to 80 Kbps.
   */
  MusicStandardStereo = 3,
  /**
   * 4: A sample rate of 48 KHz, music encoding, mono, and a bitrate of up to 96 Kbps.
   */
  MusicHighQuality = 4,
  /**
   * 5: A sample rate of 48 KHz, music encoding, stereo, and a bitrate of up to 128 Kbps.
   */
  MusicHighQualityStereo = 5,
}

export enum AudioScenario {
  /**
   * 0: Default.
   */
  Default = 0,
  /**
   * 1: Entertainment scenario, supporting voice during gameplay.
   */
  ChatRoomEntertainment = 1,
  /**
   * 2: Education scenario, prioritizing fluency and stability.
   */
  Education = 2,
  /**
   * 3: Live gaming scenario, enabling the gaming audio effects in the speaker mode in a live broadcast scenario.
   * Choose this scenario for high-fidelity music playback.
   */
  GameStreaming = 3,
  /**
   * 4: Showroom scenario, optimizing the audio quality with external professional equipment.
   */
  ShowRoom = 4,
  /**
   * 5: Gaming scenario.
   */
  ChatRoomGaming = 5,
}

export enum DegradationPreference {
  /**
   * 0: (Default) Degrades the frame rate to guarantee the video quality.
   */
  MaintainQuality = 0,
  /**
   * 1: Degrades the video quality to guarantee the frame rate.
   */
  MaintainFramerate = 1,
  /**
   * 2: Reserved for future use.
   */
  Balanced = 2,
}
